// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__1W0ML","container":"Layout_container__3gZlK"};